import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { NetworkPublicInfo } from '@tribeplatform/gql-client/types'

import { RuntimeConfigs } from '../../../../../../configs/runtime.js'

export const getWorkspaceDomain = (workspace: NetworkPublicInfo) => {
  return workspace.domainSubfolder ?? workspace.domain
}

// TODO: nexus-signup should expose a stable auth-gateway route so this URL doesn't break when its base path changes.
export const buildWorkspaceLoginUrl = (workspace: NetworkPublicInfo) => {
  return `${RuntimeConfigs.WORKSPACE_AUTH_GATEWAY_URL}/account/login/?network=${workspace.id}&networkPath=${encodeURIComponent(adminRoutes.root)}`
}

// Routes the admin panel's Hub shortcut through the auth-gateway session handoff
// (referrer=hub flow) instead of a raw cross-domain link, so the Hub loads authenticated.
export const buildHubLoginUrl = (hubPath = '/feed') => {
  return `${RuntimeConfigs.WORKSPACE_AUTH_GATEWAY_URL}/account/login/?referrer=hub&referrer_uri=${encodeURIComponent(hubPath)}`
}
